import classNames from 'classnames';
import React from 'react';
import { FormatText } from '../../lib/FormatText';
import './ArrayToTable.css';

interface ArrayToTableProps {
    data: string[][] | undefined;
    small?: boolean;
}

const ArrayToTable: React.FC<ArrayToTableProps> = ({ data, small }) => {

    if (!data || data.length === 0) { return null; }

    return (
        <table className='two-dimensional-array-table'>
            <tbody>
                {
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex} className={classNames({ 'header': rowIndex === 0, 'small' : small})}>
                            {row.map((cell: string, cellIndex: React.Key | null | undefined) => (
                                <td key={cellIndex} className={classNames('cell')}>
                                    <FormatText text={cell} />
                                </td>
                            ))}
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
};

export default ArrayToTable;
